(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-banner"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('scroll', function() {
    const video = document.querySelector('.video-background');
    const scrollPosition = window.scrollY;
    const scaleAmount = 1 + (scrollPosition / 3022); // Adjust the denominator for more or less zoom
    video.style.transform = `scale(${scaleAmount})`;
  });

  // Delay before video starts playing (we used to have a 1 second delay, currently we've opted to remove it as that causes
  // the video to not be rendered right away on mobile -- If we decide to implement this again later, we will have to use a 
  // strategy that checks for video playability, plays the video, waits about 100ms before pausing the video so that the video
  // renders immediately on mobile -- We can then play it after any delay we want)
  const playDelay = 0000; // Changed from 1000ms to zero ms with current implementation strategy

  document.addEventListener('DOMContentLoaded', function() {
  function playVideo() {
    
    const video = document.querySelector('.video-background');
    if (video) {
      setTimeout(() => {
        video.play();
      }, playDelay); // How many ms to wait before playing the video
    }
  }

  playVideo();

  // Check if we are in the Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', playVideo);
    document.addEventListener('shopify:section:unload', playVideo);
    document.addEventListener('shopify:block:select', playVideo);
    document.addEventListener('shopify:block:deselect', playVideo);
  }
});


  /*
  
  // Function to make the black overlay fade to transparent and then start playing the video
  // Adjusted function to work even when a Shopify setting was changed
  function initVideoOverlay() {
    const blackOverlay = document.querySelector('.black-overlay');

    // We implement a retry mechanism to make sure the video is not null, otherwise accessing it too early
    // means the black overlay never fades out (this was rare but it happened)
    function checkVideo() {
      
      const video = document.querySelector('.video-background');
      if (video) {

        // Here implement a method to start playng the video, wait for it to be able to play, then
        // provide a tiny 100 ms wait before pausing the video -- This is because the video had
        // delayed rendering on mobile if it was not playing causing a white screen to display for
        // a second or two after the overlay faded out
        video.preload = 'auto';
        video.play();

        const onCanPlay = () => {
          setTimeout(() => {
            video.pause();
          }, 100); // Wait 100 ms before pausing the video
          video.removeEventListener('canplay', onCanPlay);

          setTimeout(() => {
            if (blackOverlay) {
              blackOverlay.style.opacity = '0';
              setTimeout(() => {
                video.play(); // Restart video after the fade-out completes
              }, 800); // Wait for the fade-out to complete (800 ms)
            }
          }, 1000); // Start fading out after a short delay (1 second)
        };

        video.addEventListener('canplay', onCanPlay);
      } else {
        console.log('Video element not found, retrying...');
        setTimeout(checkVideo, 20); // Retry after a short delay
      }
    }

    checkVideo();
  }
  
  document.addEventListener('DOMContentLoaded', initVideoOverlay);

  // Check if we are in the Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initVideoOverlay);
    document.addEventListener('shopify:section:unload', initVideoOverlay);
    document.addEventListener('shopify:block:select', initVideoOverlay);
    document.addEventListener('shopify:block:deselect', initVideoOverlay);
  }
  
  */


// Function added to check if device is mobile and then serve either the desktop video or the mobile
// video based on that
document.addEventListener('DOMContentLoaded', function() {
    const videoElement = document.getElementById('banner-video');
    const isMobile = window.innerWidth <= 749;

  if (videoElement) {
    if (isMobile) {
        const mobileSource = videoElement.querySelector('source[data-type="mobile"]');
        if (mobileSource) {
            videoElement.src = mobileSource.src;
        }
    } else {
        const desktopSource = videoElement.querySelector('source[data-type="desktop"]');
        if (desktopSource) {
            videoElement.src = desktopSource.src;
        }
    }

  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
